function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable react/button-has-type */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
import Icon from '../Icon';
/**
 * ## WaitIndicator
 *
 * The WaitIndicator component provides users feedback letting them know that an action has
 * occurred and their request is being processed
 *
 * ## Usage
 *
 * ```jsx
 * <WaitIndicator />
 * <WaitIndicator variant="ellipsis" />
 * <WaitIndicator variant="spinner" label="Still loading... please wait." />
 * <WaitIndicator
 *  icon="loading-indicator-dark"
 *  variant="spinner"
 *  label="Still loading... please wait." />
 * <WaitIndicator
 *  icon="loading-indicator-light"
 *  variant="spinner"
 *  label="Still loading... please wait." />
 *```
 *
 * ## Props
 */

var WaitIndicator = /*#__PURE__*/function (_PureComponent) {
  _inherits(WaitIndicator, _PureComponent);

  var _super = _createSuper(WaitIndicator);

  function WaitIndicator() {
    _classCallCheck(this, WaitIndicator);

    return _super.apply(this, arguments);
  }

  _createClass(WaitIndicator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          icon = _this$props.icon,
          label = _this$props.label,
          variant = _this$props.variant;

      var _WaitIndicator$getCla = WaitIndicator.getClassName({
        className: className,
        variant: variant
      }),
          root = _WaitIndicator$getCla.root,
          dot = _WaitIndicator$getCla.dot,
          dots = _WaitIndicator$getCla.dots;

      if (icon) {
        return /*#__PURE__*/React.createElement(Icon, {
          className: root,
          label: label,
          qa: qa,
          size: "m",
          type: icon
        });
      }

      if (!icon && variant === 'spinner') {
        return /*#__PURE__*/React.createElement(Icon, {
          className: root,
          label: label,
          qa: qa,
          size: "m",
          type: "spinner"
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: root,
        "data-qa": qa
      }, /*#__PURE__*/React.createElement("div", {
        "aria-hidden": "true",
        className: dots,
        "data-qa": "".concat(qa, "#dots")
      }, /*#__PURE__*/React.createElement("div", {
        className: dot
      }), /*#__PURE__*/React.createElement("div", {
        className: dot
      }), /*#__PURE__*/React.createElement("div", {
        className: dot
      })), label && /*#__PURE__*/React.createElement("span", {
        className: "psw-sr-only",
        "data-qa": "".concat(qa, "#label")
      }, label));
    }
  }]);

  return WaitIndicator;
}(PureComponent);

var cx = classNamesFor(WaitIndicator);
/**
 * Gets the classNames attached to the style hooks for this component.
 * @returns {string} the aliased classNames for WaitIndicator
 */

WaitIndicator.getClassName = function (_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      variant = _ref.variant;
  return {
    root: cx(className, 'psw-wait-indicator', "psw-".concat(variant, "-wait-indicator"), _defineProperty({}, cx('psw-l-inline', 'psw-l-line-left', 'psw-stagger-fade-3'), !icon && variant === 'ellipsis'), {
      'psw-spin': variant === 'spinner'
    }),
    dots: cx('psw-l-line-left', 'psw-l-space-x-s'),
    dot: cx('psw-p-4xs', 'psw-bg-c', 'psw-r-pill')
  };
};
/**
 * Defines aliases for classNames used by this component
 */


WaitIndicator.useClassNames = function (classNames) {
  WaitIndicator.classNames = classNames;
};

WaitIndicator.defaultProps = {
  className: '',
  icon: '',
  label: '',
  qa: '',
  variant: 'ellipsis'
};
WaitIndicator.propTypes = {
  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Override variant if there is another icon to be used in Wait Indicator
   * beside the default variants
   */
  icon: PropTypes.oneOfType([PropTypes.oneOf(['loading-indicator-dark', 'loading-indicator-light']), PropTypes.string]),

  /**
   * label for informing reader users of waiting state
   */
  label: PropTypes.string,

  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Presentational variant to apply
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(['ellipsis', 'spinner']), PropTypes.string])
};
export default WaitIndicator;